import { render, staticRenderFns } from "./BulkTest.vue?vue&type=template&id=165f42aa&scoped=true&"
import script from "./BulkTest.vue?vue&type=script&lang=js&"
export * from "./BulkTest.vue?vue&type=script&lang=js&"
import style0 from "./BulkTest.vue?vue&type=style&index=0&id=165f42aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f42aa",
  null
  
)

export default component.exports